// Category name mapping based on actual API data
export const categoryNameMapping: { [key: string]: string } = {
  "200": "CCTV",
  "201": "Electronics",
  "202": "Clothing",
  "203": "Home & Garden",
  "204": "Sports",
  "205": "Books",
  "206": "Toys",
  "207": "Health & Beauty",
  "208": "Automotive",
  "209": "Food & Beverages",
  "210": "Office Supplies",
  "211": "Security Systems",
  "212": "Networking",
  "213": "Accessories",
  "214": "Software",
  "215": "Hardware"
};

// Function to get category name with fallbacks
export const getCategoryName = (item: any): string => {
  //console.log('getCategoryName called with item:', item);
  
  // First try the API response fields
  const apiName = item.name || item.category_name || item.title || item.label || item.categoryName || item.displayName;
  if (apiName && apiName !== item.id) {
    return apiName;
  }
  
  // Then try the hardcoded mapping
  if (categoryNameMapping[item.id]) {
    return categoryNameMapping[item.id];
  }
  
  // Finally fallback to generic name
  return `Category ${item.id}`;
};

// Function to get category name by ID only
export const getCategoryNameById = (categoryId: string): string => {
  const name = categoryNameMapping[categoryId] || `Category ${categoryId}`;
  return name;
};

// Debug function to check all category mappings
export const debugCategoryMappings = () => {
  // Debug function - console logs removed
};
